import React, { useEffect, useState } from "react";
import {
  Box,
  SpanStyled,
  ThemeLoader,
} from "../../../../components/styled/Elements";
import { userPermissionColumns } from "../../../../helpers/adminConstants/TableConstants";
import { useTranslation } from "react-i18next";
import { userPermissionsRows } from "../../../../helpers/dummyConstants";
import styled from "styled-components";
import { Table } from "react-bootstrap";
import { CustomCheckbox } from "../../../../components/styled/FormElements";
import UsersApi from "../../../../services/api/usersApi";
import { toast } from "react-toastify";

const UserPermissions = ({ permissions, setPermissions, watch }) => {
  const { t } = useTranslation();
  const userType = watch("user_type_id");

  const [loading, setLoading] = useState(false);
  const [permissionTypes, setPermissionTypes] = useState([]);
  const [permissionOperations, setPermissionOperations] = useState([]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    // value = parseInt(value);
    setPermissions((prevPermissions) => {
      const currentPermissions = prevPermissions[name] || [];
      let updatedPermissions;

      if (value === "all") {
        updatedPermissions = currentPermissions.includes("all")
          ? []
          : ["all", 1, 2, 3, 4, 5, 6];
      } else {
        updatedPermissions = currentPermissions.includes(parseInt(value))
          ? currentPermissions.filter((item) => item !== parseInt(value))
          : [...currentPermissions, parseInt(value)];
        if (updatedPermissions.includes("all")) {
          updatedPermissions = updatedPermissions.filter(
            (item) => item !== "all"
          );
        }
      }

      return { ...prevPermissions, [name]: updatedPermissions };
    });
  };

  const fetchPermissions = async () => {
    try {
      setLoading(true);
      const { data, code, message } = await UsersApi.getPermissionData();
      if (code === 200) {
        const { types, operations } = data;

        const filteredTypes = types.slice(0, -2);
        setPermissionTypes(
          filteredTypes?.map((type) =>
            Number(type?.id) === 6 ? { ...type, name: t("access_log") } : type
          )
        );
        setPermissionOperations(
          operations?.map((opr) =>
            Number(opr?.id) === 5 ? { ...opr, name: t("access_log") } : opr
          )
        );

        // const initialPermissions = filteredTypes.reduce((acc, type) => {
        //   acc[type.id] = [];
        //   return acc;
        // }, {});
        // setPermissions(initialPermissions);
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, []);

  useEffect(() => {
    if (parseInt(userType) === 3) {
      const allOptions = ["all", 1, 2, 3, 4, 5, 6];

      const selectAllPermissions = (permissions) => {
        const updatedPermissions = Object.keys(permissions).reduce(
          (acc, key) => {
            acc[key] = [...allOptions];
            return acc;
          },
          {}
        );

        return updatedPermissions;
      };
      const allSelectedPermissions = selectAllPermissions(permissions);
      setPermissions(allSelectedPermissions);
    }
  }, [userType]);

  return (
    <Box className="overflow-x-auto">
      <StyledTable>
        {loading ? (
          <ThemeLoader />
        ) : (
          <>
            <thead>
              <tr>
                {/* {userPermissionColumns.map((col, index) => (
              <th
                key={index}
                className={`${col.title === "" && "title-column"}`}
              >
                <SpanStyled size="16px" color="var(--text)" weight="bold">
                  {t(col.title)}
                </SpanStyled>
              </th>
            ))} */}
                <th>
                  <SpanStyled
                    size="16px"
                    color="var(--text)"
                    weight="bold"
                  ></SpanStyled>
                </th>
                <th className="title-column">
                  <SpanStyled size="16px" color="var(--text)" weight="bold">
                    {t("All")}
                  </SpanStyled>
                </th>
                {permissionOperations?.map((operation) => (
                  <th key={operation.id}>
                    <SpanStyled size="16px" color="var(--text)" weight="bold">
                      {t(operation.name)}
                    </SpanStyled>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {permissionTypes?.map((type) => (
                <tr key={type.id}>
                  <td>
                    <SpanStyled size="16px" color="var(--text2)">
                      {t(type.name)}
                    </SpanStyled>
                  </td>
                  <td>
                    <Box className="d-flex justify-content-center">
                      <CustomCheckbox
                        name={type.id.toString()}
                        checked={permissions[type.id]?.includes("all")}
                        value="all"
                        disabled={parseInt(userType) === 3}
                        onChange={handleChange}
                      />
                    </Box>
                  </td>
                  {permissionOperations?.map((operation) => (
                    <td key={operation.id}>
                      <Box className="d-flex justify-content-center">
                        {Number(operation.id) === 6 &&
                        Number(type?.id) !== 3 ? (
                          <SpanStyled size="16px" color="var(--text2)">
                            -
                          </SpanStyled>
                        ) : (
                          <CustomCheckbox
                            name={type.id.toString()}
                            checked={permissions[type.id]?.includes(
                              operation.id
                            )}
                            value={operation.id}
                            disabled={parseInt(userType) === 3}
                            onChange={handleChange}
                          />
                        )}
                      </Box>
                    </td>
                  ))}
                </tr>
              ))}
              {/* {userPermissionsRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {userPermissionColumns.map((col, colIndex) => (
                <td key={colIndex}>
                  <Box className="d-flex justify-content-center">
                    {colIndex === 0 ? (
                      <SpanStyled size="16px" color="var(--text2)">
                        {t(row[col.name])}
                      </SpanStyled>
                    ) : (
                      <CustomCheckbox
                        name={row.id}
                        checked={permissions[row.id].includes(col.id)}
                        value={col.id}
                        disabled={parseInt(userType) === 3}
                        onChange={handleChange}
                      />
                    )}
                  </Box>
                </td>
              ))}
            </tr>
          ))} */}
            </tbody>
          </>
        )}
      </StyledTable>
    </Box>
  );
};

export default UserPermissions;

// Styled table to match your custom styling
export const StyledTable = styled(Table)`
  border-bottom: 1px solid var(--borderLight);
  margin-bottom: 0;
  thead tr {
    border-bottom: 1px solid var(--borderLight);
  }
  th,
  td {
    text-align: center;
    vertical-align: middle;
    padding: 2rem 16px;
    border: none;
  }

  th {
    font-size: 16px;
    font-weight: 500;
    color: var(--text);
  }

  td {
    font-size: 14px;
  }

  th.title-column {
    width: 160px;
  }
`;
